import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.4687 3.68279C13.3216 3.51974 13.1249 3.42857 12.9201 3.42857C12.7153 3.42857 12.5186 3.51974 12.3715 3.68279L6.348 10.4464L3.61629 7.35242C3.46822 7.18895 3.27052 7.0976 3.0648 7.0976C2.85908 7.0976 2.66138 7.18895 2.51332 7.35242C2.44126 7.43286 2.38399 7.52899 2.34489 7.63515C2.30579 7.74131 2.28564 7.85536 2.28564 7.97057C2.28564 8.08578 2.30579 8.19982 2.34489 8.30598C2.38399 8.41214 2.44126 8.50827 2.51332 8.58871L5.79937 12.3172C5.94648 12.4803 6.14322 12.5714 6.348 12.5714C6.55277 12.5714 6.74952 12.4803 6.89663 12.3172L13.4687 4.95179C13.546 4.87147 13.6078 4.77353 13.6501 4.66425C13.6924 4.55498 13.7142 4.4368 13.7142 4.31729C13.7142 4.19778 13.6924 4.0796 13.6501 3.97033C13.6078 3.86105 13.546 3.76311 13.4687 3.68279Z",
		fill: "#387DFF"
	})]
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
